export const routeChanged = 'ROUTE_CHANGED';
export const userSearch = 'SEARCH_PERFORMED';
export const briefPrinted = 'BRIEF_PRINTED';
export const logAnalytics = 'LOG_ANALYTICS_INVOKED';
export const logClicks = 'LOG_CLICKS';
export const logFilters = 'LOG_FILTER';
export const logEvent = 'LOG_EVENT';
export const logDownloads = 'LOG_DOWNLOADS';

const actionCreators = {
  viewPage: (user, location, title) => ({
    type: routeChanged,
    user,
    location,
    title,
  }),

  ranSearch: (user, searchPhrase) => ({
    type: userSearch,
    user,
    searchPhrase,
  }),

  printedBrief: (user, url) => ({
    type: briefPrinted,
    user,
    url,
  }),

  logAnalytics: log => ({
    type: logAnalytics,
    log,
  }),

  logClick: (user, category, origin, organization, url, uniqueId) => ({
    type: logClicks,
    user,
    category,
    origin,
    organization,
    url,
    uniqueId,
  }),

  logDownload: (user, category) => ({
    type: logDownloads,
    user,
    category,
  }),

  logEvent: (user, category, action, label, value) => ({
    type: logEvent,
    user,
    category,
    action,
    label,
    value,
  }),

  logFilter: (user, filterOrigin, filterValue) => ({
    type: logFilters,
    user,
    filterOrigin,
    filterValue,
  }),
};

const queuePageView = (user, location, title) => dispatch => {
  setTimeout(() => {
    dispatch(actionCreators.viewPage(user, location, title));
  }, 0);
  // this is pretty bad, but trying to pull the right title
  // after react helmet does its thing
  // https://github.com/nfl/react-helmet/issues/189
};

const logFilterAction = (user, filterOrigin, filterValue) => dispatch => {
  setTimeout(() => {
    dispatch(actionCreators.logFilter(user, filterOrigin, filterValue));
  }, 0);
  // this is pretty bad, but trying to pull the right title
  // after react helmet does its thing
  // https://github.com/nfl/react-helmet/issues/189
};

const logEventAction = ga => dispatch => {
  setTimeout(() => {
    dispatch(
      actionCreators.logEvent(
        ga.user,
        ga.category,
        ga.action,
        ga.label,
        ga.value
      )
    );
  }, 0);
  // this is pretty bad, but trying to pull the right title
  // after react helmet does its thing
  // https://github.com/nfl/react-helmet/issues/189
};

const logClickAction = (
  user,
  category,
  origin,
  organization,
  url,
  uniqueId
) => dispatch => {
  const primaryOrganization =
    organization && organization[0] ? organization[0].title : '';

  setTimeout(() => {
    dispatch(
      actionCreators.logClick(
        user,
        category,
        origin,
        primaryOrganization,
        url,
        uniqueId
      )
    );
  }, 0);
  // this is pretty bad, but trying to pull the right title
  // after react helmet does its thing
  // https://github.com/nfl/react-helmet/issues/189
};

const logDownloadAction = (
  user,
  category
) => dispatch => {
  setTimeout(() => {
    dispatch(
      actionCreators.logDownload(user, category)
    );
  }, 0);
  // this is pretty bad, but trying to pull the right title
  // after react helmet does its thing
  // https://github.com/nfl/react-helmet/issues/189
};

export {
  actionCreators,
  queuePageView,
  logClickAction,
  logFilterAction,
  logEventAction,
  logDownloadAction
};
